import axios from "axios";
import * as d3 from "d3";
import {axisTextDim1, numberFormat, XaxisAttribute} from '../functions'
import crossfilter from "crossfilter";
import reset from "crossfilter";
// import * as dc from 'dc';
export default function (chart, divId, vizName) {
    var url = '/api/fetchData/' + chart.data.syspk + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.get(url).then(res => {
        let data = res.data;

        console.warn("crossfilter Id:", divId)

        var nestByData = d3.nest().key(function (d) {
            return d.dim1_id;
        })

        // Create the crossfilter for the relevant dimensions and groups.
        var salesman = crossfilter(data);
        var all = salesman.groupAll();

        var salesman_dim = salesman.dimension(d => {
            return d.dim2_id
        });
        var salesman_rev = salesman_dim.group().reduceSum(function (a) {
            return a.metric2;
        });

        var year_month_dim = salesman.dimension(d => d.dim1_id);
        var year_month_rev = year_month_dim.group().reduceSum(function (a) {
            return a.metric2;
        });

        var product_dim = salesman.dimension(d => d.dim3_id);
        var product_rev = product_dim.group().reduceSum(function (a) {
            return a.metric2;
        });

        var order_dim = salesman.dimension(d => d.metric1);
        var order_rev = order_dim.group().reduceSum(function (a) {
            return a.metric3;
        });

        var charts = [
            barChart(0)
                .dimension(year_month_dim)
                .group(year_month_rev)
                .x(d3.scaleLinear()
                    .domain([(d3.min(data, d => {
                        return d.dim1_id
                    })), d3.max(data, d => {
                        return d.dim1_id
                    })])
                    .rangeRound([0, 750])),

            barChart(1)
                .dimension(product_dim)
                .group(product_rev)
                .x(d3.scaleLinear()
                    .domain([(d3.min(data, d => {
                        return d.dim3_id
                    }) - 1), d3.max(data, d => {
                        return d.dim3_id
                    })])
                    .rangeRound([0, 250])),

            barChart(2)
                .dimension(order_dim)
                .group(order_rev)
                .x(d3.scaleLinear()
                    .domain([0, d3.max(data, d => {
                        return d.metric1
                    })])
                    .rangeRound([0, d3.max(data, d => {
                        return d.metric1
                    })])),

            barChart(3)
                .dimension(salesman_dim)
                .group(salesman_rev)
                .x(d3.scaleLinear()
                    .domain([(d3.min(data, d => {
                        return d.dim2_id
                    }) - 1), d3.max(data, d => {
                        return d.dim2_id
                    })])
                    .rangeRound([0, 800]))
        ];

        /** Given our array of charts, which we assume are in the same order as
         the chart elements in the DOM, bind the charts to the DOM and render them.
         We also listen to the chart's brush events to update the display. */
        var chartC = d3.selectAll('.chart').data(charts);
        var list = d3.selectAll('.list').data([salesmanList]);

        // Render the total.
        d3.selectAll('#total').text(numberFormat(salesman.size()));

        renderAll();

        // Renders the specified chart or list.
        function render(method) {
            d3.select(this).call(method);
        }

        // Whenever the brush moves, re-rendering everything.
        function renderAll() {
            chartC.each(render);
            list.each(render);
            d3.select('#active').text(numberFormat(all.value()));
        }

        window.reset = i => {
            charts[i].filter(null);
            renderAll();
        };

        function salesmanList(div) {
            var salesmanByData = nestByData.entries(year_month_dim.top(50));
            div.each(function () {
                var dim1_name = d3.select(this).selectAll('div')
                    .data(salesmanByData, d => d.key);

                dim1_name.exit().remove();

                dim1_name.enter()
                    .append('div')
                    .attr('class', null)
                    .append('div')
                    .attr('class', null)
                    .text(d => (d.dim1_name))
                    .merge(dim1_name);

                var salesman = dim1_name.order().selectAll('.salesman').data(d => d.values, d => d.index);

                salesman.exit().remove();

                var salesmanEnter = salesman.enter().append('div').attr('class', 'salesman');

                salesmanEnter.append('div').attr('class', 'time').text(d => d.dim1_name);
                salesmanEnter.append('div').attr('class', 'salesman').text(d => d.dim2_name);
                salesmanEnter.append('div').attr('class', 'category').text(d => d.dim3_name);
                salesmanEnter.append('div').attr('class', 'orders').text(d => numberFormat(d.metric1));
                salesmanEnter.append('div').attr('class', 'orders').text(d => numberFormat(d.metric2));
                salesmanEnter.append('div').attr('class', 'orders').text(d => numberFormat(d.metric3));

                salesmanEnter.merge(salesman);

                salesman.order();
            });
        }

        function barChart(value) {
            if (!barChart.id) barChart.id = 0;
            let x, brushDirty, dimension, group, round, gBrush;
            let y = d3.scaleLinear().range([100, 0]);
            var id = barChart.id++;
            var axis = d3.axisBottom()
            //                .ticks(5);
            var brush = d3.brushX();

            function chartC(div) {
                var width = x.range()[1];
                var height = y.range()[0];

                var y1AxisLabel = d3.scaleLinear().range([height, 0]);
                var y2AxisLabel = d3.scaleLinear().range([height, 0]);

                brush.extent([[0, 0], [width, height]]);

                y.domain([0, group.top(1)[0].value]);
                var y1Scale = y1AxisLabel.domain([0, d3.max(data, function (d) {
                    return d.metric2;
                })]);
                var y2Scale = y2AxisLabel.domain([0, d3.max(data, function (d) {
                    return d.metric3;
                })]);

                div.each(function () {
                    var div = d3.select(this);
                    var g = div.select('g');

                    // Create the skeletal chart.
                    if (g.empty()) {
                        div.select('.title')
                            .append('a')
                            .attr('href', `javascript:reset(${id})`)
                            .text('  reset')
                            .style('display', 'none');

                        if ((value == 3) || (value == 1) || (value == 0)) {
                            g = div.append('svg')
                                .attr('width', width + chart.margin.left + chart.margin.right)
                                .attr('height', height + chart.margin.top + chart.margin.bottom)
                                .append('g')
                                .call(d3.axisLeft(y1Scale).ticks(5).tickFormat(numberFormat))
                                .attr('transform', `translate(${chart.margin.left},${chart.margin.top})`);
                        }

                        if (value == 2) {
                            g = div.append('svg')
                                .attr('width', width + chart.margin.left + chart.margin.right)
                                .attr('height', height + chart.margin.top + chart.margin.bottom)
                                .append('g')
                                .call(d3.axisLeft(y2Scale).ticks(5).tickFormat(numberFormat))
                                .attr('transform', `translate(${chart.margin.left},${chart.margin.top})`);
                        }

                        g.append('clipPath')
                            .attr('id', `clip-${id}`)
                            .append('rect')
                            .attr('width', width)
                            .attr('height', height);

                        g.selectAll('.bar')
                            .data(['background', 'foreground'])
                            .enter()
                            .append('path')
                            .attr('class', d => `${d} bar`)
                            .datum(group.all())
                            .style('fill', '#ccc');

                        g.selectAll('.foreground.bar')
                            .attr('clip-path', `url(#clip-${id})`)
                            .style('fill', 'steelblue');

                        if ((value != 3) && (value != 1) && (value != 0)) {
                            g.append('g')
                                .attr('class', 'axis')
                                .attr('transform', `translate(0,${height})`)
                                .call(axis)
                                .selectAll('text')
                                .style('text-anchor', 'end')
                                .attr('dx', '-.3em')
                                .attr('dy', '+.5em')
                                .attr('transform', 'rotate(-60)')
                                .text(function (d) {
                                    if (d.length > 8)
                                        return d.substring(0, 8) + '...'
                                    else
                                        return d
                                });

                            g.append('text')
                                .attr('transform', 'rotate(-90)')
                                .attr('y', 0 - chart.margin.left + 5)
                                .attr('x', 0 - (height / 2))
                                .attr('dy', '1em')
                                .style('text-anchor', 'middle')
                                .style('fill', '#4000ff')
                                .text(chart.y2AxisDisplayName)
                        }

                        // Draw the axis
                        if (value == 3) {
                            let x1Scale = d3.scaleBand().domain(data.map(function (d) {
                                return d.dim2_name
                            })).range([0, 800]);
                            g.append("g")
                                .attr('transform', `translate(0,${height})`)
                                .call(d3.axisBottom(x1Scale))
                                .selectAll('text')
                                .style('text-anchor', 'start')
                                .attr('dx', XaxisAttribute)
                                .attr('dy', '-0.55em')
                                .attr('transform', 'rotate(-50)')
                                .text(axisTextDim1);

                            g.append('text')
                                .attr('transform', 'rotate(-90)')
                                .attr('y', 0 - chart.margin.left + 5)
                                .attr('x', 0 - (height / 2))
                                .attr('dy', '1em')
                                .style('text-anchor', 'middle')
                                .style('fill', '#4000ff')
                                .text(chart.y1AxisDisplayName)
                        } else if (value == 1) {
                            let x1Scale = d3.scaleBand().domain(data.map(function (d) {
                                return d.dim3_name
                            })).range([0, 250]);
                            g.append("g")
                                .attr('transform', `translate(0,${height})`)
                                .call(d3.axisBottom(x1Scale))
                                .selectAll('text')
                                .style('text-anchor', 'start')
                                .attr('dx', XaxisAttribute)
                                .attr('dy', '-.55em')
                                .attr('transform', 'rotate(-50)')
                                .text(axisTextDim1);

                            g.append('text')
                                .attr('transform', 'rotate(-90)')
                                .attr('y', 0 - chart.margin.left + 5)
                                .attr('x', 0 - (height / 2))
                                .attr('dy', '1em')
                                .style('text-anchor', 'middle')
                                .style('fill', '#4000ff')
                                .text(chart.y1AxisDisplayName)
                        } else if (value == 0) {
                            let x1Scale = d3.scaleBand().domain(data.map(function (d) {
                                return d.dim1_name
                            }).sort(d3.ascending)).range([0, 750]);
                            g.append("g")
                                .attr('transform', `translate(0,${height})`)
                                .call(d3.axisBottom(x1Scale))
                                .selectAll('text')
                                .style('text-anchor', 'end')
                                .attr('dx', '-.5em')
                                .attr('dy', '+.5em')
                                .attr('transform', 'rotate(-75)')
                                .text(function (d) {
                                    if (d.length > 8)
                                        return d.substring(0, 8) + '..'
                                    else
                                        return d
                                });

                            g.append('text')
                                .attr('transform', 'rotate(-90)')
                                .attr('y', 0 - chart.margin.left + 5)
                                .attr('x', 0 - (height / 2))
                                .attr('dy', '1em')
                                .style('text-anchor', 'middle')
                                .style('fill', '#4000ff')
                                .text(chart.y1AxisDisplayName)
                        }

                        // Initialize the brush component with pretty resize handles.
                        gBrush = g.append('g').attr('class', 'brush').call(brush);

                        gBrush.selectAll('.handle--custom')
                            .data([{type: 'w'}, {type: 'e'}])
                            .enter()
                            .append('path')
                            .attr('cursor', 'ew-resize')
                            .attr('d', resizePath)
                            .style('display', 'none');
                    }

                    // Only redraw the brush if set externally.
                    if (brushDirty !== false) {
                        var filterVal = brushDirty;
                        brushDirty = false;

                        div.select('.title a').style('display', d3.brushSelection(div) ? null : 'none');

                        if (!filterVal) {
                            g.call(brush);
                            g.selectAll(`#clip-${id} rect`).attr('x', 0).attr('width', width)
                                .call(d3.axisLeft(y2AxisLabel).ticks(5).tickFormat(numberFormat));
                            g.selectAll('.brush-handle').style('display', 'none');

                            renderAll();
                        } else {
                            var range = filterVal.map(x);
                            brush.move(gBrush, range);
                        }
                    }
                    g.selectAll('.bar').attr('d', barPath);
                });

                function barPath(groups) {
                    var path = [];
                    let i = -1;
                    var n = groups.length;
                    let d;
                    while (++i < n) {
                        d = groups[i];
                        path.push('M', x(d.key), ',', height, 'V', y(d.value), 'h9V', height);
                    }
                    return path.join('');
                }

                function resizePath(d) {
                    var e = +(d.type === 'e');
                    var x = e ? 1 : -1;
                    var y = height / 3;
                    return `M${0.5 * x},${y}A6,6 0 0 ${e} ${6.5 * x},${y + 6}V${2 * y - 6}A6,6 0 0 ${e} ${0.5 * x},${2 * y}ZM${2.5 * x},${y + 8}V${2 * y - 8}M${4.5 * x},${y + 8}V${2 * y - 8}`;
                }
            }

            brush.on('start.chart', function () {
                var div = d3.select(this.parentNode.parentNode.parentNode);
                div.select('.title a').style('display', null);
            });

            brush.on('brush.chart', function () {
                var g = d3.select(this.parentNode);
                var brushRange = d3.event.selection || d3.brushSelection(this); // attempt to read brush range
                var xRange = x && x.range(); // attempt to read range from x scale
                let activeRange = brushRange || xRange; // default to x range if no brush range available

                var hasRange = activeRange && activeRange.length === 2 && !isNaN(activeRange[0]) && !isNaN(activeRange[1]);

                if (!hasRange) return; // quit early if we don't have a valid range

                // calculate current brush extents using x scale
                let extents = activeRange.map(x.invert);

                // if rounding fn supplied, then snap to rounded extents
                // and move brush rect to reflect rounded range bounds if it was set by user interaction
                if (round) {
                    extents = extents.map(round);
                    activeRange = extents.map(x);

                    if (d3.event.sourceEvent && d3.event.sourceEvent.type === 'mousemove') {
                        d3.select(this).call(brush.move, activeRange);
                    }
                }

                // move brush handles to start and end of range
                g.selectAll('.brush-handle')
                    .style('display', null)
                    .attr('transform', (d, i) => `translate(${activeRange[i]}, 0)`);

                // resize sliding window to reflect updated range
                g.select(`#clip-${id} rect`)
                    .attr('x', activeRange[0])
                    .attr('width', activeRange[1] - activeRange[0]);

                // filter the active dimension to the range extents
                dimension.filterRange(extents);

                // re-render the other charts accordingly
                renderAll();
            });

            brush.on('end.chart', function () {
                // reset corresponding filter if the brush selection was cleared.
                if (!d3.brushSelection(this)) {
                    reset(id);
                }
            });

            chartC.margin = function (_) {
                if (!arguments.length) return chart.margin;
                chart.margin = _;
                return chartC;
            };

            chartC.x = function (_) {
                if (!arguments.length) return x;
                x = _;
                axis.scale(x);
                return chartC;
            };

            chartC.y = function (_) {
                if (!arguments.length) return y;
                y = _;
                return chartC;
            };

            chartC.dimension = function (_) {
                if (!arguments.length) return dimension;
                dimension = _;
                return chartC;
            };

            chartC.filter = _ => {
                if (!_) dimension.filterAll();
                brushDirty = _;
                return chartC;
            };

            chartC.group = function (_) {
                if (!arguments.length) return group;
                group = _;
                return chartC;
            };

            chartC.round = function (_) {
                if (!arguments.length) return round;
                round = _;
                return chartC;
            };

            chartC.gBrush = () => gBrush;

            return chartC;
        }
    })
}
